module.exports = __webpack_public_path__ + "education-48.0cb747bcdcb51a47a217.eot";


//////////////////
// WEBPACK FOOTER
// C:/Users/INMOGR/Desktop/Angular Project/src/assets/fonts/line-icons-pro/education/webfont/education-48.eot
// module id = ../../../../../src/assets/fonts/line-icons-pro/education/webfont/education-48.eot
// module chunks = styles